export default "__VITE_ASSET__Bz8rM2Mr__"